import {Alert, IconButton, InputAdornment, Stack, TextField, Typography} from '@mui/material';
import {useState, useEffect} from 'react';
import API from '../../../services/API';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from "../../Frames/Layout"
import {LoadingButton} from '@mui/lab';
import Loader from '../../Tools/Loader';
import { Close } from '@mui/icons-material';
import PDF from '../../Inputs/PDF';
import Category from '../../Inputs/Category';
import Course from '../../Inputs/Course';
import Variant from '../../Inputs/Variant';

export default function Form(){

    const navigate = useNavigate();
    const {id} = useParams();

    const [product, setProduct] = useState({});
    const [status, setStatus] = useState('loading')
    const statusIs = str => str === status
    const statusIn = arr => arr.includes(status)

    useEffect(() => {

        if(id !== 'new'){

            API.get(`/products/${id}`)
                .then(r => {
                    setProduct(r.data)
                    setStatus('ready')
                })
                .catch(e => setStatus('error404'))

        }else{
            setProduct(defaultProduct)
            setStatus('ready')
        }
                
    }, [id])


    const handleChange = props => {
        let copy = {...product};
        Object.assign(copy, props);
        return setProduct(copy);
    }

    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit');

        if(id === 'new'){

            API.post(`/products`, generateNewProduct(product))
                .then(r => navigate('/admin/prices'))
                .catch(e => setStatus('error' + e.response.status))
        }else{
            API.put(`/products/${id}`, product)
                .then(r => navigate('/admin/prices'))
                .catch(e => setStatus('error' + e.response.status))
        }
    }

    const handlePdf = pdf => {
        if(pdf){

            API.upload(`/pdf`, pdf)
                .then(r => setProduct({...product, pdf: r.data}))
                .catch(e => setStatus('errorPDF'))

        }else{

            API.delete(`/files/${product.pdf?.name}`)

            setProduct({...product, pdf: null})
        }
    }

    return <Layout title="" tab="prices" menu="admin">

        {(status.startsWith('error') || statusIn(['ready','submit'])) && 
        
            <form onSubmit={e => handleSubmit(e)} style={{marginTop: 60}}>

                <Stack direction='column' spacing={3} sx={{maxWidth: 500, margin: 'auto'}}>

                    <Stack direction='row' justifyContent='space-between' alignItems='center'>

                        <Typography variant='h2'>{id === 'new' ? 'Ajouter un' : 'Modifier le '} tarif</Typography>

                        <Link to="/admin/prices">
                            <IconButton>
                                <Close />
                            </IconButton>
                        </Link>

                    </Stack>

                    {id !== 'new' && <Typography>{product.title}</Typography>}

                    {status.startsWith('error') && 
                        <Alert severity='error'>{errors[status] || errors.error500}</Alert>
                    }

                    <Variant
                        value={product.variant}
                        onChange={variant => handleChange({variant})}
                        disabled={id !== 'new'}
                        required={true}
                    />

                    {id === 'new' && <>
                    
                        <Course
                            value={product.course}
                            onChange={course => handleChange({course})}
                            required={true}
                            disabled={id !== 'new'}
                        />
                    
                        <Category
                            value={product.category}
                            onChange={category => handleChange({category})}
                            disabled={id !== 'new'}
                            required
                        />

                    </>}

                    <TextField
                        label={['dpc','dpc-pi'].includes(product.variant?.id) ? "Montant de l'indemnité DPC" : "Prix"}
                        type='number'
                        size='small'
                        value={product.price}
                        onChange={e => handleChange({price: e.target.value})}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>€</InputAdornment>,
                            min: 0,
                            step: 0.01
                        }}
                        required
                    />

                    <TextField
                        label='Durée de la formation'
                        type='number'
                        size='small'
                        value={product.hours}
                        onChange={e => handleChange({
                            hours: e.target.value,
                            duration: Math.round((e.target.value || 0) * 60)
                        })}
                        InputProps={{
                            min: 0,
                            step: 0.1,
                            endAdornment: <InputAdornment position='end'>heures</InputAdornment>
                        }}
                        required
                    />

                    {['dpc','dpc-pi'].includes(product.variant?.id) &&
                        <TextField
                            label="Référence de l'action DPC"
                            size='small'
                            value={product.reference2 || ''}
                            onChange={e => handleChange({reference2: e.target.value})}
                        />
                    }

                    <PDF
                        id='product-pdf'
                        value={product.pdf} 
                        onChange={handlePdf}
                    />

                    <LoadingButton 
                        variant='contained' 
                        type='submit' 
                        loading={statusIs('submit')}
                    >
                        Valider
                    </LoadingButton>

                </Stack>

            </form>
        }

        {statusIs('loading') && <Loader />}

    </Layout>
}


const errors = {
    error404: "Ce tarif a été supprimé.",
    error409: "Ce tarif existe déjà.",
    error500: "Une erreur s'est produite. Vérifiez le formulaire.",
    errorPDF: "PDF trop lourd ou format incorrect."
}


const defaultProduct = {
    reference: null,
    type: {id: 'course', title: 'Formation'},
    variant: {id: 'standard'},
    price: 0,
    duration: 0,
    hours: 0,
    category: {id: 'dentaire', title: 'Dentaire'},
    reference2: null,
    pdf: null
};


const generateNewProduct = p => {
    let data = {...p};
    data.id = p.course?.id + '_' + p.variant?.id + '_' + p.category?.id;
    data.reference = p.course?.id;
    data.title = p.course?.title + ' ' + p.variant?.id?.toUpperCase() + ' ' + p.category?.title;
    return data;
}